module.exports = " <navbar></navbar> <index-content></index-content> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/layout/IndexLayout.vue
 ** module id = 24
 ** module chunks = 2
 **/